import React, {Component} from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import {connected, fuBy, fuStatus} from "../../config/constants";
import * as R from "ramda";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import M from "moment";
import moment from "moment";
import { notRequiredStatus, validateField } from "../config";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";

class CRMFollowUpFollowUp extends Component {
    constructor(props) {
        super(props);
        this.initialErrorValue = {
            followUpStatus: null,
            followUpMethod: null,
            connected: null,
            nextAppointmentDate: null,
            followUpResult: null,
        }
        this.state = {
          fuStatusOptions: fuStatus,
          fuByOptions: fuBy,
          connectedOptions: connected,
          followUpData: {
            followUpDate: moment().format("DD-MM-YYYY"),
            followUpStatus: null,
            followUpMethod: null,
            connected: null,
            nextAppointmentDate: null,
            followUpResult: null,
            cancelOptions: [],
          },
          errors: this.initialErrorValue,
        };
    };

    componentDidMount() {
        if (!R.isNil(this.props.data)) {
            if (this.props.data?.followUpStatus === "DROP") {
              this.fetchCancelOptions(this.props.data);
            }
            this.setState((prevValue) => ({
                ...prevValue,
                followUpData: {
                    ...this.props.data,
                    cancelReason:
                        this.props.data?.followUpStatus === "DROP"
                          ? mapToObjectDDL(this.props.data?.cancelReason?.value, this.props.data?.cancelReason?.key)
                          : null,
                    followUpStatus: this.state.fuStatusOptions.find(item => item.value === this.props.data.followUpStatus),
                    followUpMethod: this.state.fuByOptions.find(item => item.value === this.props.data.followUpMethod),
                    connected: this.state.connectedOptions.find(item => item.value === this.props.data.connected),
                },
            }));
        }
    };

    fetchCancelOptions = async (data) => {
      const { handleTriggerLoading, setError } = this.props || {};
      if(handleTriggerLoading){
        handleTriggerLoading();
      }
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        menuName: "Follow Up CRM H23",
        setError: setError,
        args: {
          paramFilters: { bizparCategory: "DRP_FU", status: "ACTIVE" },
        },
      });
      if(handleTriggerLoading){
        handleTriggerLoading();
      }
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState({
          cancelOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        });
      }
    };

    handleSubmit = () => {
        const { followUpData } = this.state;
        const errors = validateField(followUpData);
        
        if (errors) {
            this.setState(prev => ({ ...prev, errors }));
            return;
        }

        this.setState(prev => ({ ...prev, errors: this.initialErrorValue }));

        const requestData = {
            status: followUpData?.followUpStatus?.value,
            connected: followUpData.connected?.value,
            method: followUpData.followUpMethod?.value || null,
            nextAppointmentDate: followUpData?.nextAppointmentDate,
            followUpDate: moment().format("DD-MM-YYYY"),
            followUpResult: followUpData?.followUpResult,
            cancelReason: followUpData?.cancelReason?.value || null
        };

        this.props.onSubmit(requestData);
    };

    setValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            followUpData: {
                ...prevValue.followUpData,
                [name]: value,
            },
        }));
    };
   
    setValueFollowUpStatus = (name, value) => {
        if(notRequiredStatus.includes(value?.value) && this.state.followUpData.nextAppointmentDate){
            this.setValue("nextAppointmentDate", null)
        }
        this.setValue(name, value)
    };

    setDateToFormat = (date) => {
        return R.isNil(date) ? null : typeof date === "string" ? date : M(date).format("DD-MM-YYYY");
    };

    render() {
        const { errors, followUpData } = this.state;
        const { 
            followUpDate, 
            followUpStatus, 
            followUpMethod, 
            connected, 
            nextAppointmentDate, 
            followUpResult,
            cancelReason
        } = followUpData || {};

        const isStatusNotMandatory = notRequiredStatus.includes(followUpStatus?.value);
        return (
            <>
                <div className="grid grid-2x gap-20px">
                    <div id="grid-1">
                        <SimpleDate
                            name="followUpDate"
                            label="Follow Up Date"
                            disabled
                            date={this.setDateToFormat(followUpDate)}
                            onChange={({value}) => this.setValue("followUpDate", value)}
                        />
                        <SimpleDDL
                            mandatory
                            errorMessage={errors.followUpStatus}
                            box="search"
                            id="select_options_follow_up_status"
                            name="followUpStatus"
                            label="Follow Up Status"
                            readOnly={this.props.readOnly}
                            value={followUpStatus}
                            options={this.state.fuStatusOptions}
                            onChange={(value, {name}) => {
                                this.setValueFollowUpStatus(name, value)
                                if (value?.value === "DROP") {
                                  this.fetchCancelOptions();
                                }
                            }}
                        />
                        {followUpStatus?.value === "DROP" ? (
                          <SimpleDDL
                            mandatory
                            errorMessage={errors?.cancelReason}
                            box="search"
                            id="select_options_drop_reason"
                            name="cancelReason"
                            label="Alasan DROP"
                            readOnly={this.props.readOnly}
                            value={cancelReason}
                            options={this.state?.cancelOptions}
                            onChange={(value, { name }) => this.setValue(name, value)}
                          />
                        ) : (
                         <SimpleDDL
                            mandatory
                            errorMessage={errors.followUpMethod}
                            box="search"
                            id="select_options_follow_up_by"
                            name="followUpMethod"
                            label="Cara Follow Up"
                            readOnly={this.props.readOnly}
                            value={followUpMethod}
                            options={this.state.fuByOptions}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        )}
                        <SimpleDDL
                            mandatory
                            errorMessage={errors.connected}
                            box="search"
                            id="select_options_connected"
                            name="connected"
                            label="Terhubung/Tidak"
                            readOnly={this.props.readOnly}
                            value={connected}
                            options={this.state.connectedOptions}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDate
                            mandatory={!isStatusNotMandatory}
                            errorMessage={errors.nextAppointmentDate}
                            name="nextAppointmentDate"
                            label="Next Appointment Date"
                            disabled={this.props.readOnly || isStatusNotMandatory}
                            date={this.setDateToFormat(nextAppointmentDate)}
                            onChange={(value) => this.setValue("nextAppointmentDate", moment(value).format("DD-MM-YYYY"))}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleTextArea
                            mandatory
                            errorMessage={errors.followUpResult}
                            id="input_text_follow_up_result"
                            typeInputCase="normal"
                            name="followUpResult"
                            label="Hasil Follow Up"
                            readOnly={this.props.readOnly}
                            value={followUpResult}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                    </div>
                </div>
                {!this.props.readOnly && (
                    <FlexView style={{justifyContent: "end"}}>
                        <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                    </FlexView>
                )}
            </>
        )
    }

}

export default CRMFollowUpFollowUp;